import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildPyramid: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const tiers = [
        { size: 9, y: 0 },
        { size: 7, y: 1 },
        { size: 5, y: 2 },
        { size: 3, y: 3 },
        { size: 1, y: 4 },
    ];

    for (const tier of tiers) {
        const offset = (9 - tier.size) / 2;
        brush.layer(
            offset,
            offset + tier.size - 1,
            offset,
            offset + tier.size - 1,
            tier.y,
            BLOCK.Sandstone,
        );
    }
};
